import { z } from "zod";
import { IService } from "./IService";

export const ServiceCheckListItemSchema = z.object({
    id: z.number(),
    title: z.string(),
    description: z.string(),
    isPhotoRequired: z.boolean(),
    position: z.number(),
    Service: z.number(),
});

export type IServiceCheckListItem = z.infer<typeof ServiceCheckListItemSchema>;

export const getNextNegativeId = (items: IServiceCheckListItem[]): number => {
    const minId = Math.min(...items.map((item) => item.id), 0);
    return minId - 1;
};

export const getEmtyServiceCheckListItem = (
    checkListItems: IServiceCheckListItem[],
    service: IService,
): IServiceCheckListItem => {
    return {
        id: getNextNegativeId(checkListItems),
        title: "",
        description: "",
        isPhotoRequired: false,
        position: checkListItems.length + 1,
        Service: service.id,
    };
};
